import { render, staticRenderFns } from "./ReporteComponente.vue?vue&type=template&id=72683f2c"
import script from "./ReporteComponente.vue?vue&type=script&lang=js"
export * from "./ReporteComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports